export const IMG = {
  heroSpread: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&q=85&w=1200",
  heroBuffet: "https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=85&w=1200",
  cateringSpread: "https://images.unsplash.com/photo-1564638305579-5e395c9b62c7?auto=format&fit=crop&q=85&w=1200",
  feastTable: "https://images.unsplash.com/photo-1577308856961-8e9ec50d0c67?auto=format&fit=crop&q=85&w=1200",
  peopleDining: "https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&q=85&w=1200",
  mealPrepBox: "https://images.unsplash.com/photo-1737999174440-8cbe8ba510c1?auto=format&fit=crop&q=85&w=800",
  gourmetTray: "https://images.unsplash.com/photo-1671363272297-a07dd4ee16c7?auto=format&fit=crop&q=85&w=800",
  chickenSaladBowl: "https://images.unsplash.com/photo-1671363465562-2428cbbb764a?auto=format&fit=crop&q=85&w=800",
  buffetLine: "https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=85&w=1200",
  weddingTable: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&q=85&w=1200",
  corporateLunch: "https://images.unsplash.com/photo-1565895405138-6c3a1555da6a?auto=format&fit=crop&q=85&w=1200",
  chefPlating: "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?auto=format&fit=crop&q=85&w=1200",
};

export const MEALS = [
  {
    id: "agashe-peanut-chicken",
    name: "Agashe Peanut Chicken",
    desc: "West African peanut stew, slow-braised halal chicken, toasted groundnuts, jasmine rice.",
    price: 14.5,
    img: "https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&q=85&w=800",
    tags: ["Chef Favorite", "High Protein"],
    cats: ["chef", "protein"],
    cal: 640,
    protein: 44,
    chef: "Our signature — the peanut base is ground fresh every morning and finished with a whisper of Scotch bonnet.",
    ingredients: "Halal chicken thigh, ground peanuts, tomato, ginger, garlic, Scotch bonnet, jasmine rice",
  },
  {
    id: "spiced-chicken-kabsa",
    name: "Spiced Chicken Kabsa",
    desc: "Saudi-style spiced basmati, roasted halal chicken, raisins, toasted almonds, kabsa spice.",
    price: 14,
    img: "https://images.unsplash.com/photo-1781332149415-f420708ab98f?auto=format&fit=crop&q=85&w=800",
    tags: ["Chef Favorite"],
    cats: ["chef"],
    cal: 680,
    protein: 40,
    chef: "The rice cooks in the chicken's own broth — that is where the depth comes from.",
    ingredients: "Halal chicken, basmati rice, kabsa spice, tomato, raisins, almonds, black lime",
  },
  {
    id: "jerk-beef",
    name: "Jerk Beef",
    desc: "Slow-grilled halal beef, house jerk rub, charred scallion, coconut rice & peas.",
    price: 15.5,
    img: "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&q=85&w=800",
    tags: ["High Protein", "Spicy"],
    cats: ["protein"],
    cal: 590,
    protein: 48,
    chef: "Marinated 24 hours. The smoke is real — no shortcuts.",
    ingredients: "Halal beef, allspice, thyme, Scotch bonnet, scallion, coconut milk, kidney beans",
  },
  {
    id: "kofta-kebabs",
    name: "Kofta Kebabs",
    desc: "Hand-rolled halal beef kofta, sumac onions, herbed bulgur, garlic toum.",
    price: 14.5,
    img: "https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?auto=format&fit=crop&q=85&w=800",
    tags: ["High Protein"],
    cats: ["protein"],
    cal: 560,
    protein: 38,
    chef: "Rolled by hand, never pressed. Parsley goes into the meat, not on top.",
    ingredients: "Halal ground beef, parsley, onion, baharat, bulgur, sumac, garlic, lemon",
  },
  {
    id: "sayadiya-tilapia",
    name: "Sayadiya Tilapia with Rice",
    desc: "Levantine fisherman's rice — caramelized onion, warm spices, flaky tilapia fillet.",
    price: 15,
    img: "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?auto=format&fit=crop&q=85&w=800",
    tags: ["Chef Favorite"],
    cats: ["chef"],
    cal: 520,
    protein: 36,
    chef: "The onions are cooked to the edge of burnt — that is the soul of sayadiya.",
    ingredients: "Tilapia, long-grain rice, caramelized onion, cumin, turmeric, pine nuts",
  },
  {
    id: "baked-mac-bechamel",
    name: "Baked Macaroni with Béchamel",
    desc: "Egyptian-style baked pasta, silky béchamel, spiced halal beef, golden crust.",
    price: 13,
    img: "https://images.unsplash.com/photo-1543339308-43e59d6b73a6?auto=format&fit=crop&q=85&w=800",
    tags: ["Comfort"],
    cats: ["comfort"],
    cal: 710,
    protein: 32,
    chef: "Three layers, always. The middle layer is the one everyone fights over.",
    ingredients: "Penne, halal ground beef, milk, butter, flour, nutmeg, tomato",
  },
  {
    id: "shrimp-pesto-pasta",
    name: "Coconut Pistachio Pesto Shrimp Pasta",
    desc: "Seared shrimp, coconut-pistachio pesto, linguine, charred lemon.",
    price: 16,
    img: "https://images.unsplash.com/photo-1551183053-bf91a1d81141?auto=format&fit=crop&q=85&w=800",
    tags: ["Chef Favorite", "High Protein"],
    cats: ["chef", "protein"],
    cal: 610,
    protein: 34,
    chef: "Pistachio instead of pine nuts, coconut cream instead of dairy. Trust us.",
    ingredients: "Shrimp, linguine, pistachio, basil, coconut cream, garlic, lemon",
  },
  {
    id: "lamb-shank",
    name: "Lamb Shank",
    desc: "Slow-braised halal lamb shank, fall-off-the-bone tender, over fragrant yellow rice with caramelized onions, rich braising jus and fresh parsley.",
    price: 17.99,
    img: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&q=85&w=800",
    tags: ["High Protein"],
    cats: ["protein"],
    cal: 650,
    protein: 42,
    chef: "The shank braises low and slow for four hours in its own spiced jus, then gets a final roast so the outside caramelizes while the inside stays meltingly soft.",
    ingredients: "Halal lamb shank, yellow rice, caramelized onion, tomato, parsley, warm spices (cinnamon, cardamom, black pepper), garlic",
  },
  {
    id: "harissa-salmon",
    name: "Harissa Glazed Salmon",
    desc: "Seared salmon, smoky harissa glaze, herbed freekeh, charred greens.",
    price: 16.5,
    img: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&q=85&w=800",
    tags: ["High Protein", "Low Carb"],
    cats: ["protein", "light"],
    cal: 490,
    protein: 41,
    chef: "Ninety seconds skin-side down. The glaze lacquers; it should never burn.",
    ingredients: "Salmon, harissa, honey, freekeh, kale, preserved lemon",
  },
  {
    id: "chicken-shawarma-plate",
    name: "Chicken Shawarma Rice Plate",
    desc: "Turmeric-marinated halal chicken, saffron rice, garlic sauce, sumac salad.",
    price: 14,
    img: "https://images.unsplash.com/photo-1561651823-34feb02250e4?auto=format&fit=crop&q=85&w=800",
    tags: ["Comfort", "High Protein"],
    cats: ["comfort", "protein"],
    cal: 660,
    protein: 45,
    chef: "Our best seller three weeks running. The garlic sauce is made fresh daily.",
    ingredients: "Halal chicken, turmeric, saffron rice, garlic, lemon, sumac",
  },
  {
    id: "moroccan-chickpea-tagine",
    name: "Moroccan Slow-Simmered Chickpeas & Vegetable Couscous",
    desc: "Tender chickpeas and a colorful medley of carrots, zucchini, potato and onion, slow-simmered in a rich tomato sauce with warm Moroccan spices, served over light, fluffy couscous and finished with fresh herbs. 100% Vegan | Plant-Based | Dairy-Free.",
    price: 12.5,
    img: "https://images.unsplash.com/photo-1541518763669-27fef04b14ea?auto=format&fit=crop&q=85&w=800",
    tags: ["Plant-Forward", "Vegan"],
    cats: ["plant"],
    cal: 560,
    protein: 18,
    chef: "Proof that a plant-forward plate can still eat like a feast.",
    ingredients: "Chickpeas, carrots, zucchini, potato, onion, tomato, Moroccan spices, couscous, parsley, cilantro",
  },
  {
    id: "halloumi-grain-bowl",
    name: "Grilled Halloumi & Za'atar Grain Bowl",
    desc: "Seared halloumi, za'atar grains, roasted vegetables, whipped feta.",
    price: 13,
    img: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=85&w=800",
    tags: ["Plant-Forward"],
    cats: ["plant", "light"],
    cal: 540,
    protein: 26,
    chef: "The halloumi is seared to order so it arrives with a proper crust.",
    ingredients: "Halloumi, za'atar, farro, zucchini, peppers, whipped feta",
  },
];

export const EXTRAS = [
  {
    id: "garlic-tomato-chickpeas",
    name: "Braised Garlic-Tomato Chickpeas",
    desc: "Slow-braised chickpeas, confit garlic, smoked paprika.",
    price: 6,
    img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&q=85&w=800",
    kind: "Side",
  },
  {
    id: "fattoush-salad",
    name: "Fattoush Salad",
    desc: "Crisp romaine, radish, sumac vinaigrette, toasted pita.",
    price: 6.5,
    img: "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&q=85&w=800",
    kind: "Side",
  },
  {
    id: "greek-salad",
    name: "Greek Salad",
    desc: "Cucumber, tomato, kalamata olives, barrel-aged feta.",
    price: 6.5,
    img: "https://images.unsplash.com/photo-1546793665-c74683f339c1?auto=format&fit=crop&q=85&w=800",
    kind: "Side",
  },
  {
    id: "sweet-plantains",
    name: "Caramelized Sweet Plantains",
    desc: "Ripe plantains, caramelized edges, flake salt.",
    price: 5.5,
    img: "https://images.unsplash.com/photo-1628840042765-356cda07504e?auto=format&fit=crop&q=85&w=800",
    kind: "Side",
  },
  {
    id: "baklava",
    name: "Baklava",
    desc: "Forty layers of phyllo, pistachio, orange-blossom honey.",
    price: 3.99,
    img: "https://images.unsplash.com/photo-1598110750624-207050c4f28c?auto=format&fit=crop&q=85&w=800",
    kind: "Dessert",
  },
  {
    id: "royal-cake",
    name: "Royal Cake",
    desc: "Pistachio layer cake, rose cream, gold-dusted petals.",
    price: 3.99,
    img: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?auto=format&fit=crop&q=85&w=800",
    kind: "Dessert",
  },
];

export const TESTIMONIALS = [
  {
    name: "Amina R.",
    role: "Weekly subscriber, Alexandria VA",
    quote: "The Agashe Peanut Chicken is the single best meal-prep dish I have ever had. I reorder it every single week.",
    stars: 5,
  },
  {
    name: "David K.",
    role: "Office manager, Washington DC",
    quote: "HiPlate caters our Friday team lunches. On time, beautifully presented, and everyone — halal or not — asks where the food is from.",
    stars: 5,
  },
  {
    name: "Sara & Omar",
    role: "Wedding, Fairfax VA",
    quote: "They catered our 180-guest wedding flawlessly. The kabsa station was the talk of the night.",
    stars: 5,
  },
  {
    name: "Yusuf M.",
    role: "Returning customer, Rockville MD",
    quote: "Finally, halal food that is genuinely gourmet. The rewards points mean my delivery is usually free.",
    stars: 5,
  },
];

export const DELIVERY_NOTICE = "Delivery only across the DMV area (DC · Maryland · Northern Virginia). No pickup options available.";
export const PROMO = { code: "HIPLATE15", rate: 0.15, label: "15% off your first order" };
export const MIN_MEALS = 5;
export const DELIVERY_FEE = 5.99;
export const FREE_DELIVERY_OVER = 75;
export const SUBSCRIPTION_RATE = 0.1;

export const fmt = (n) => `$${n.toFixed(2)}`;
